import { Injectable } from '@angular/core';
import { environment } from '../../../environments/default/environment';
import { Module } from '@shared/enums/Module';

@Injectable({
    providedIn: 'root'
})
export class ModuleService {
    projectConfiguration = environment.projectConfiguration;
    activeModules = this.projectConfiguration.modules;

    get isOrganisationModuleActive(): boolean {
        return this.activeModules.includes(Module.Organisation);
    }

    get isReportModuleActive(): boolean {
        return this.activeModules.includes(Module.Reports);
    }

    get isReportTemplateModuleActive(): boolean {
        return this.activeModules.includes(Module.ReportTemplates);
    }

    get isSummaryReportModuleActive(): boolean {
        return this.activeModules.includes(Module.SummaryReports);
    }

    get isGlossaryModuleActive(): boolean {
        return this.activeModules.includes(Module.Glossary);
    }

    get isHyperlinksModuleActive(): boolean {
        return this.activeModules.includes(Module.Hyperlinks);
    }

    get isFaqModuleActive(): boolean {
        return this.activeModules.includes(Module.Faq);
    }

    get isLanguageSelectionAvailable(): boolean {
        return this.projectConfiguration.availableLanguages.length > 1;
    }

    get isCascadedReportingActive(): boolean {
        return this.activeModules.includes(Module.CascadedReporting);
    }

    get isMailingActive(): boolean {
        return this.activeModules.includes(Module.Mailing);
    }
}
